import Hero from './Hero'
import { Link } from 'react-router-dom'

const SellerCard = ({ Seller }) => {
  const posterUrl = Seller.image  
  const detaiilURL = `/seller/${Seller.id}`

  return (
    <div className='col-lg-3 col-md-12 col-xs-12 p-4'>
      <div className="card"  style={{ height: "440px" }}>
        <div className='p-2'>
          <img
            src={posterUrl}
            className="card-img-top"
            alt={Seller.name}
            style={{
              height: '250px',      // Atur tinggi sesuai kebutuhan
              objectFit: 'cover',   // Biar proporsional & rapi
            }}
          />
        </div>
        <div className="card-body">
          <h5 className="card-title text-gray">{Seller.name}</h5>
          <p className="card-text">
            {Seller.description.length > 30 
            ? Seller.description.substring(0, 30) + '...' 
            : Seller.description}
          </p>
          <Link to={detaiilURL} className="btn btn-primary">Detail</Link>
        </div>
      </div>
    </div>
  );
}

const Home =  ({keyword, searchResults}) => {
  const resultsHtml = searchResults.map((obj , i) => {
      return <SellerCard Seller={obj} key={i} />
  })

  return (
    <>
      {resultsHtml != "" ? (
        <>
          <div className="container">
            <div className="row mt-4">
              {/* Kolom kiri untuk gambar */}
              <div className="col-lg-6 text-center">
                <img 
                  src="images/kakilima_maskot.png" 
                  alt="Contoh Gambar" 
                  className="img-fluid rounded shadow"
                  style={{ maxWidth: '250px', height: 'auto' }}
                />
              </div>

              {/* Kolom kanan untuk tulisan */}
              <div className="col-lg-6 d-flex align-items-center">
                <div>
                  <h2 className="mb-3">Selamat Datang Di Kaki Lima</h2>
                  <p>
                    Platform ini menghadirkan pengalaman belanja yang sederhana dan dekat dengan keseharian.
                    Di sini kamu bisa menemukan berbagai produk lokal, informasi penjual, serta cerita di balik
                    setiap barang yang ditawarkan. Jadikan Kaki Lima sebagai ruang untuk mendukung usaha kecil
                    sekaligus menikmati nuansa khas pasar tradisional dalam format digital
                  </p>
                </div>
              </div>
            </div>

            {/* Baris berikutnya untuk hasil dinamis */}
            <div className="row mt-4">
              {resultsHtml}
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="container">
            <div className="row">
              <div className="col-lg-8 offset-lg-2">
                <p className="lead p-5">
                  
                </p>
              </div>
            </div>
          </div>
  
          <Hero text="About Us" />
          <div className="container">
            <div className="row">
              <div className="col-lg-8 offset-lg-2">
                <p className="lead p-5">
                 
                </p>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );  
}

  
export default Home